<template>
  <div class="row">
    <BaseTextInput
      v-bind="escolaridadeNome"
      v-bind:disabled="readonly"
      v-bind:value="value.escolaridadeNome"
    />
    <BaseTextInput
      v-bind="dataConclusao"
      v-bind:disabled="readonly"
      v-bind:value="formattedDataConclusao"
    />
    <BaseTextInput
      v-bind="instituicaoEnsino"
      v-bind:disabled="readonly"
      v-bind:value="computedInstituicaoEnsino"
    />
  </div>
</template>

<script>
export default {
  name: "BaseDadoEscolar",
  inheritAttrs: false,
  props: {
    escolaridadeNome: {
      type: Object,
      required: true
    },
    dataConclusao: {
      type: Object,
      required: true
    },
    instituicaoEnsino: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      readonly: true
    };
  },
  computed: {
    formattedDataConclusao() {
      const { format, toBrazilianDate } = this.$utils.DateTime;

      return format(this.value.dataConclusao, toBrazilianDate);
    },
    computedInstituicaoEnsino() {
      const { instituicaoEnsino } = this.value;

      let result = null;

      if (instituicaoEnsino) {
        const { nome, sigla, pais } = instituicaoEnsino;

        result = nome;

        if (sigla) {
          result += ` (${sigla})`;
        }

        if (pais) {
          result += ` - ${pais.nome}`;
        }
      }

      return result;
    }
  }
};
</script>

<style scoped>
.row {
  margin-bottom: 0;
}
</style>
